"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIllustration = _interopRequireDefault(require("../withIllustration"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IllustrationSmallHouse = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 64 40",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#FFFFFF",
            x: "0",
            y: "16",
            width: "40",
            height: "24"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#091E43",
            points: "12 0 52 0 40 16 0 16"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("polygon", {
            fill: "#C3D0D8",
            points: "40 16 52 0 64 16 64 40 40 40"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "24",
            y: "24",
            width: "8",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#091E43",
            x: "48",
            y: "24",
            width: "8",
            height: "8"
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)("rect", {
            fill: "#C3D0D8",
            x: "8",
            y: "24",
            width: "8",
            height: "16"
          })]
        })
      })
    })
  });
};
var _default = exports.default = (0, _withIllustration.default)('IllustrationSmallHouse')(IllustrationSmallHouse);